import { CANNED_RESOURCE_ACTIONS } from "components/dashboard/TrainSAM/CannedResponses/enum";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import AddButton from "components/ui/Button/AddButton/AddButton";
import { baseResourceActions } from "routes/enum";

const { UPDATE } = baseResourceActions;

const { EDIT_CANNED_RESOURCE } = CANNED_RESOURCE_ACTIONS;

const UpdatesTableActionButton = ({ editText, onClick, updateResource }) => {
    return (
        <div>
            <ComponentAccessControl
                baseResources={[`${UPDATE}_${updateResource}`]}>
                <AddButton
                    btnText={editText}
                    hasIcon={false}
                    onClick={() => onClick?.(EDIT_CANNED_RESOURCE)}
                />
            </ComponentAccessControl>
        </div>
    );
};

export default UpdatesTableActionButton;
